import PropTypes from 'prop-types'

import Statistics from 'components/Dashboard/cards/common/Statistics'
import GreyColumn from 'components/Dashboard/cards/common/GreyColumn'

import useStyles from './styles'

const MedicationContent = ({
  medication,
  directions,
  notes,
  unit,
  substitutions,
  writtenDate,
  quantity,
  refills,
  daysSupply,
}) => {
  const classes = useStyles()

  const topRows = [
    {
      label: 'Medication',
      value: medication,
    },
    {
      label: 'Directions',
      value: directions,
    },
    {
      label: 'Notes',
      value: notes,
    },
  ]

  const bottomRows = [
    {
      label: 'Unit',
      value: unit,
    },
    {
      label: 'Substitutions',
      value: substitutions,
    },
    {
      label: 'Written date',
      value: writtenDate,
    },
  ]

  return (
    <div>
      {topRows.map(({ label, value }) => (
        <GreyColumn label={label} value={value} key={label} className={classes.greyColumnRoot} />
      ))}

      <Statistics quantity={quantity} refills={refills} daysSupply={daysSupply || 0} />

      {bottomRows.map(({ label, value }) => (
        <GreyColumn label={label} value={value} key={label} className={classes.greyColumnRoot} />
      ))}
    </div>
  )
}
MedicationContent.propTypes = {
  medication: PropTypes.string.isRequired,
  directions: PropTypes.string.isRequired,
  notes: PropTypes.string,
  unit: PropTypes.string.isRequired,
  substitutions: PropTypes.string.isRequired,
  writtenDate: PropTypes.string.isRequired,
  quantity: PropTypes.string.isRequired,
  refills: PropTypes.string.isRequired,
  daysSupply: PropTypes.number.isRequired,
}
MedicationContent.defaultProps = {
  notes: '',
}

export default MedicationContent
